import { ImageMap, getImage, importAll } from "..";

declare const require: any;

const imagesOrganization: ImageMap = importAll(
  require.context("../organization", false, /\.(png|jpe?g|svg)$/)
);

export default imagesOrganization;
export const getTemplateCultureImg = (valueTemplateImage: string) => {
  const filteredImages = Object.entries(imagesOrganization).find(
    ([item, value], index) => getImage(item) === valueTemplateImage
  );
  if (filteredImages) return filteredImages[1];
  else return "";
};
